
import { Link, useLocation } from 'react-router-dom';

export const NavLinks = () => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="hidden md:flex items-center space-x-8">
      <Link 
        to="/" 
        className={`text-sm font-medium transition-colors ${
          isActive('/') ? 'text-[#0EA5E9]' : 'text-tranquil-neutral hover:text-[#0EA5E9]'
        }`}
      >
        Home
      </Link>
      <Link 
        to="/features" 
        className={`text-sm font-medium transition-colors ${
          isActive('/features') ? 'text-[#0EA5E9]' : 'text-tranquil-neutral hover:text-[#0EA5E9]'
        }`}
      >
        Features
      </Link>
      <Link 
        to="/pricing" 
        className={`text-sm font-medium transition-colors ${
          isActive('/pricing') ? 'text-[#0EA5E9]' : 'text-tranquil-neutral hover:text-[#0EA5E9]'
        }`}
      >
        Pricing
      </Link>
      <Link 
        to="/blog" 
        className={`text-sm font-medium transition-colors ${
          isActive('/blog') ? 'text-[#0EA5E9]' : 'text-tranquil-neutral hover:text-[#0EA5E9]'
        }`}
      >
        Blog
      </Link>
      <Link 
        to="/about" 
        className={`text-sm font-medium transition-colors ${
          isActive('/about') ? 'text-[#0EA5E9]' : 'text-tranquil-neutral hover:text-[#0EA5E9]'
        }`}
      >
        About
      </Link>
      <Link 
        to="/faq" 
        className={`text-sm font-medium transition-colors ${
          isActive('/faq') ? 'text-[#0EA5E9]' : 'text-tranquil-neutral hover:text-[#0EA5E9]'
        }`}
      >
        FAQ
      </Link>
    </nav>
  );
};
